import React from 'react'
import PropTypes from 'prop-types'

const BetaBanner = props => (
    <div className='beta-banner-wrapper'>
        <img src={`pictures/beta/${props.color == 'blue' ? 'blue' : 'grey'}-banner.svg`} {...props}/>
    </div>
)

BetaBanner.propTypes = {
    color: PropTypes.string
}

export default BetaBanner



// WEBPACK FOOTER //
// ./src/components/banner/BetaBanner.js